import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import ErrorModal from "./ErrorModal";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const SessionExpireModal = () => {
    const { isAppTimeout, closeSesionExpireModal } = useContext(AuthContext);
    const navigate = useNavigate();
    const { t } = useTranslation();
    return (_jsx(ErrorModal, { title: t("_Logged_out"), deleteError: isAppTimeout === "expire"
            ? t("_Session_expired._Please_login_again.")
            : t("_Logged_out_another_session"), errorModal: isAppTimeout === "expire" || isAppTimeout === "remote_logout", buttonTxt: t("_Sign_In"), setErrorModal: () => {
            closeSesionExpireModal();
            navigate("/auth");
        } }));
};
export default SessionExpireModal;
